module.exports = __webpack_public_path__ + "static/img/rage_strike-seasonalShop@2x.5e0d3d3d.png";